/**
 *
 * Ranking
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const NoSelect = styled.span`
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
`;

// http://unicode.org/emoji/charts-13.0/full-emoji-list.html
const ranking = {
  1: String.fromCodePoint(0x1f947),
  2: String.fromCodePoint(0x1f948),
  3: String.fromCodePoint(0x1f949),
};

export function Ranking({ pos }) {
  if (!pos) {
    return '';
  }
  if (!ranking[pos]) {
    return pos.toLocaleString();
  }
  return [<NoSelect>{`${ranking[pos]} `}</NoSelect>, pos.toLocaleString()];
}

Ranking.propTypes = {
  pos: PropTypes.number,
};

export default Ranking;
